import { LS_KEY, EMPTY, LIST_KEYS } from "./vaultSchema";

export function readVault() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return { ...EMPTY };
    const parsed = JSON.parse(raw);
    // Legacy migration: pre-v1.3 stored `passports` → `photo_ids`.
    if (Array.isArray(parsed?.passports) && !Array.isArray(parsed?.photo_ids)) {
      parsed.photo_ids = parsed.passports.map((p) => ({
        ...p,
        id_type: p.id_type || "passport",
      }));
      delete parsed.passports;
    }
    return { ...EMPTY, ...parsed };
  } catch {
    return { ...EMPTY };
  }
}

export function writeVault(v) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(v));
  } catch {
    /* non-fatal */
  }
}

/**
 * Merge a local vault with the authoritative cloud copy. Cloud entries win
 * on id collision; local-only entries are kept (so things added while
 * offline don't get clobbered on next /vault GET).
 */
export function mergeVaults(local, cloud) {
  const out = { ...EMPTY };
  for (const cat of LIST_KEYS) {
    const cloudList = Array.isArray(cloud?.[cat]) ? cloud[cat] : [];
    const localList = Array.isArray(local?.[cat]) ? local[cat] : [];
    const cloudIds = new Set(cloudList.map((e) => e.id));
    const localOnly = localList.filter((e) => !cloudIds.has(e.id));
    out[cat] = [...cloudList, ...localOnly];
  }
  return out;
}
